export default "__VITE_ASSET__7BWUABV1__"